import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@components/IconButton';
import { IconLightMode, IconDarkMode } from '@components/icons';
import { useUIStore } from '@store/uiStore';

export interface ThemeSwitcherProps {
  /** Additional CSS classes */
  className?: string;
}

export const ThemeSwitcher = ({ className = '' }: ThemeSwitcherProps) => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useUIStore();

  const isDarkMode = theme === 'dark';

  // Apply theme to document when it changes
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [isDarkMode]);

  return (
    <IconButton
      variant="outlined"
      size="large"
      aria-label={
        isDarkMode
          ? t('theme.switchToLight', 'Switch to light mode')
          : t('theme.switchToDark', 'Switch to dark mode')
      }
      onClick={toggleTheme}
      className={className}
    >
      {isDarkMode ? <IconLightMode size={20} /> : <IconDarkMode size={20} />}
    </IconButton>
  );
};
